import { render } from "./milestones-section.vue?vue&type=template&id=562c5e1b&scoped=true&ts=true"
import script from "./milestones-section.vue?vue&type=script&lang=ts"
export * from "./milestones-section.vue?vue&type=script&lang=ts"

import "./milestones-section.vue?vue&type=style&index=0&id=562c5e1b&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-562c5e1b"]])

export default __exports__